const Form019EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        title: {
            // header: "School-based After-school Learning and Support Programmes {{endDateOfCurrentSchoolYear}} School Year ",
            title1: "Section I (to be completed by School Supervisor)",
            title2: "Total basic salary received and amount of Contract Gratuity entitled",
            // title3: "Section I (to be completed by Supervisor of School)",
        },
        note: {
            note1: "EDB Circular Nos. {{note1}} (NET Scheme in Primary Schools)",
            note2: "{{note2}}",
            note3: "EDB Circular Nos. {{note3}} (Enhanced NET Scheme in Secondary Schools)",
            note4: "{{note4}}",
            note5: "(Value lookup from parameter file. The fields to be lookup are highlighted in yellow.)",
            note6: "(a) I certify that the following Native-speaking English Teacher (NET) is entitled to a Contract Gratuity",
            note7: "I certify that the above information is correct.",
            note8: "I undertake to inform the Funds Section of the Education Bureau via the Senior School Development Officer as soon as possible if there is any change in the above information provided and to repay the Government for any overpayment of Contract Gratuity to the staff concerned.",
        },
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        // schoolChoose:
        //     "Application for the Payment of Contract Gratuity for Teachers under the Native-speaking English Teacher (NET) Scheme in Primary Schools or Application for the Payment of Contract Gratuity for Teachers under the Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools",
        information: "Basic Information",
        schoolChoose: "Please Select",
        schoolChooseOption: {
            Primary:
                "Application for the Payment of Contract Gratuity for Teachers under the Native-speaking English Teacher (NET) Scheme in Primary Schools",
            Secondary:
                "Application for the Payment of Contract Gratuity for Teachers under the Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools",
        },
        nameOfSchool: "Name of School",
        schoolCode: "School Code",
        ssdo: "Responsible Senior School Development Officer",
        ssdoOption: [
            "Central and Western District",
            "Southern District",
            "Wan Chai District",
            "Islands District",
            "Hong Kong East District",
            "Kowloon City District",
            "Sham Shui Po District",
            "Sai Kung District",
            "Kwun Tong District",
            "Wong Tai Sin District",
            "Yau Tsim Mong District",
            "Tai Po District",
            "North District",
            "Sha Tin District",
            "Kwai Chung & Tsing Yi District",
            "Tsuen Wan District",
            "Tuen Mun District",
            "Yuen Long District",
        ],
        telNumber: "Tel. No",
        fax: "Fax No",

        name: "Name",
        hkid: "HK Identity Card No.",
        staffRef: "Staff Ref. No.",
        dateOfCommencement: "Date of Commencement of Contract",
        dateOfCompletion: "Date of Completion of Contract",
        document: "Upload supporting document",
        noPayLeave: "Period(s) of no-pay leave during the contract",

        contractPeriod: "Contract Period ",
        from: "From",
        to: "To",
        totalBasicSalary: "(a) Total basic salary received",
        percentageOfBasicSalary: "(b) Percentage of basic salary",
        amountOfContractGratuityEntitled:
            "(c) Amount of Contract Gratuity entitled (c) = (a) x (b)",
        amountOfEmployer:
            "(d) Amount of employer's contribution to the MPF Scheme for the NET",
        amountOfGratuityPayable:
            "(e) Amount of Gratuity payable to the NET (e) = (c) – (d)",
        payment: "Payment",
        firstPayment: "First payment",
        secondPayment: "Second payment",
        proposedDate: "Proposed Date",
        amountOfGratuity: "Amount of Gratuity",
        proposedDateFirst: "Proposed Date (First Payment)",
        proposedDateSecond: "Proposed Date (Second Payment)",
        amountOfGratuityFirst: "Amount of Gratuity (First Payment)",
        amountOfGratuitySecond: "Amount of Gratuity (Second Payment)",
        signatureOfSupervisor: "Signature of Supervisor",
        name1: "Name of Supervisor",
        notes: {
            note1: "The first payment of gratuity covering the completed period of resident service is payable to the NET not earlier than 4 clear working days before the commencement of the summer vacation at the end of the contract. The second payment relating to the period of summer vacation at the end of the contract should be made not earlier than 4 clear working days before the expiry of the contract.",
            note2: "The completed application form should reach the Funds Section, via the SSDO, at least 4 weeks before the expected date of the first payment.",
        },
        // header: "(please put a “√”in the appropriate box) ",
        // reason: "Reason(s):",
        // headerOption: {
        //     header1:
        //         "My school, in compliance with the requirements of the Programme, applies for the School-based Grant to organise school-based after-school activities for eligible students. ",
        //     header2:
        //         "My school does not wish to receive the School-based Grant.  ",
        // },
        errorMsg: {
            schoolCodeMin: "School code must be exactly 4 digits",
            faxMin: "Fax number must be exactly 8 digits",
            telMin: "Telephone number must be exactly 8 digits",
            staffRefMin: "Staff ref. no. must be exactly 8 digits",
            E0001: "The date should not be earlier than 4 working days before the date of completion of contract",
            E0002: "Please input a valid reason",
            notTheSame: "(i) and (ii) should not be checked at the same time",
            E0003: "Amount of gratuity (first payment) and amount of gratuity (second payment) must add up to amount of gratuity payable to the NET",
            totalBasicSalaryMin: "The minimum value of this field is 0",
            E0004:"Amount of employer's contribution to the MPF Scheme for the NET should not be greater than Amount of Contract Gratuity entitled."
        },
    },
};
export default Form019EN;
